import React, { useRef, useEffect, useState } from 'react';
import { Button, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import useSWR from 'swr';
import { InteractieveToolMobileDetail } from './InteractieveToolMobileDetail';
import { ScatterChartOneDimensionalInteractieveTool } from '../../ScatterChartOneDimensional/ScatterChartOneDimensionalSmall';
import { LineChartSimple } from '../../LineChart/LineChart';
import { getGridStringOperators } from '@mui/x-data-grid';
import { SelectionPanel } from './SelectionMenuComponents/SelectionPanel';

export const InteractieveToolMobile = (props: any) => {
  const {
    benchColors,
    selectedGemeente,
    selectedBenchmarks,
    selectedIndicators,
    setSelectedIndicators,
    blobUrl,
    blobUrlSamenvattingen,
    setSelectedBenchmarks,
    setSelectedIndicatorData,
    setSelectedGemeente,
    selectedIndicator,
    setSelectedIndicator,
    gemeenteColor,
    searchParams,
    setSearchParams,
    selectedIndicatorData,
    vgColor,
    interfaceColor,
  } = useData();

  const { additionalData } = props;

  const titleSection = useRef(null);
  const tableSection = useRef(null);
  const detailSection = useRef(null);

  const [dataGemeente, setDataGemeente] = useState([]);
  const [cols, setCols] = useState([]);
  const [gemeenteLijst, setGemeenteLijst] = useState([]);
  const [benchmarkLijst, setBenchmarkLijst] = useState([]);
  const [hasRunOnce, setHasRunOnce] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [themas, setThemas] = useState([]);
  const [indicators, setIndicators] = useState([]);
  const [indicatorThema, setIndicatorThema] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  const fetcher = (url: any) => fetch(url).then((res) => res.json());

  const swrOptions = {
    // revalidateOnFocus: false,
    // revalidateOnMount: false,
    // revalidateOnReconnect: false,
    // refreshWhenOffline: false,
    // refreshWhenHidden: false,
    // refreshInterval: 0,
  };

  const { data: d_indicator } = useSWR(
    `${blobUrl}d_indicator.json`,
    fetcher,
    swrOptions,
  );
  const { data: d_thema } = useSWR(
    `${blobUrl}d_thema.json`,
    fetcher,
    swrOptions,
  );
  const { data: f_samenvatting_indicatoren } = useSWR(
    `${blobUrlSamenvattingen}f_samenvatting_indicatoren.json`,
    fetcher,
    swrOptions,
  );
  const { data: d_indicator_detail } = useSWR(
    `${blobUrl}d_indicator_detail.json`,
    fetcher,
    swrOptions,
  );
  const { data: d_ruimte } = useSWR(
    `${blobUrl}d_ruimte.json`,
    fetcher,
    swrOptions,
  );
  const { data: d_benchmark } = useSWR(
    `${blobUrl}d_benchmark.json`,
    fetcher,
    swrOptions,
  );
  const { data: f_indicator_thema } = useSWR(
    `${blobUrl}f_indicator_thema.json`,
    fetcher,
    swrOptions,
  );

  let f_benchmark: any[] = [];
  let f_benchmark_10: any[] = [];

  const gemeenteFile = `f_ruimte_${selectedGemeente.id}`;
  const { data: f_gemeente } = useSWR(
    `${blobUrl}Overzicht/${gemeenteFile}.json`,
    fetcher,
    swrOptions,
  );

  const { data: f_gemeente_10 } = useSWR(
    `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedGemeente.id}.json`,
    fetcher,
    swrOptions,
  );

  // selectedBenchmarks.forEach((d: any, i: number) => {
  //   benchmarkFiles.push(`f_ruimte_${selectedBenchmarks[i].id}`);
  //   const { data: f_benchmark } = useSWR(
  //     `${blobUrl}Overzicht/${benchmarkFiles[i]}.json`,
  //     fetcher,
  //   );
  //   f_benchmark[i] = f_benchmarkTMP;
  // });

  const { data: f_benchmark0_10 } = useSWR(
    selectedBenchmarks[0] &&
      Object.keys(selectedBenchmarks[0]).length > 0 &&
      selectedBenchmarks[0].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[0].id}.json`
      : null,
    fetcher,
    swrOptions,
  );

  const { data: f_benchmark1_10 } = useSWR(
    selectedBenchmarks[1] &&
      Object.keys(selectedBenchmarks[1]).length > 0 &&
      selectedBenchmarks[1].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[1].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark2_10 } = useSWR(
    selectedBenchmarks[2] &&
      Object.keys(selectedBenchmarks[2]).length > 0 &&
      selectedBenchmarks[2].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[2].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark3_10 } = useSWR(
    selectedBenchmarks[3] &&
      Object.keys(selectedBenchmarks[3]).length > 0 &&
      selectedBenchmarks[3].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[3].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark4_10 } = useSWR(
    selectedBenchmarks[4] &&
      Object.keys(selectedBenchmarks[4]).length > 0 &&
      selectedBenchmarks[4].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[4].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark5_10 } = useSWR(
    selectedBenchmarks[5] &&
      Object.keys(selectedBenchmarks[5]).length > 0 &&
      selectedBenchmarks[5].constructor === Object
      ? `${blobUrl}Overzicht_10/f_ruimte_evolutie_${selectedBenchmarks[5].id}.json`
      : null,
    fetcher,
    swrOptions,
  );

  const { data: f_benchmark0 } = useSWR(
    selectedBenchmarks[0] &&
      Object.keys(selectedBenchmarks[0]).length > 0 &&
      selectedBenchmarks[0].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[0].id}.json`
      : null,
    fetcher,
    swrOptions,
  );

  const { data: f_benchmark1 } = useSWR(
    selectedBenchmarks[1] &&
      Object.keys(selectedBenchmarks[1]).length > 0 &&
      selectedBenchmarks[1].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[1].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark2 } = useSWR(
    selectedBenchmarks[2] &&
      Object.keys(selectedBenchmarks[2]).length > 0 &&
      selectedBenchmarks[2].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[2].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark3 } = useSWR(
    selectedBenchmarks[3] &&
      Object.keys(selectedBenchmarks[3]).length > 0 &&
      selectedBenchmarks[3].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[3].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark4 } = useSWR(
    selectedBenchmarks[4] &&
      Object.keys(selectedBenchmarks[4]).length > 0 &&
      selectedBenchmarks[4].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[4].id}.json`
      : null,
    fetcher,
    swrOptions,
  );
  const { data: f_benchmark5 } = useSWR(
    selectedBenchmarks[5] &&
      Object.keys(selectedBenchmarks[5]).length > 0 &&
      selectedBenchmarks[5].constructor === Object
      ? `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[5].id}.json`
      : null,
    fetcher,
    swrOptions,
  );

  // const { data } = useSWR(shouldFetch ? '/api/data' : null, fetcher);

  // const { data: f_benchmark_1 } = useSWR(
  //   `${blobUrl}Overzicht/f_ruimte_${selectedBenchmarks[0].id}.json`,
  //   fetchData,
  // );

  const prepData = () => {
    f_samenvatting_indicatoren.map((d: any) => {
      d.joinKey = `A${d.idIndicator}`;
      if (d.idIndicatorP2 !== null) {
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}_C${d.idIndicatorP2}`;
      } else if (d.idIndicatorP1 !== null) {
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}`;
      }
      return d;
    });

    f_gemeente.map((d: any) => {
      d.topLevel = 0;
      d.idIndicatorTop = d.idIndicator;
      d.joinKey = `A${d.idIndicator}`;
      if (d.idIndicatorP2 !== null) {
        d.topLevel = 2;
        d.idIndicatorTop = d.idIndicatorP2;
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}_C${d.idIndicatorP2}`;
      } else if (d.idIndicatorP1 !== null) {
        d.topLevel = 1;
        d.idIndicatorTop = d.idIndicatorP1;
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}`;
      }

      return d;
    });

    f_gemeente_10.map((d: any) => {
      d.joinKey = `A${d.idIndicator}`;
      if (d.idIndicatorP2 !== null) {
        d.topLevel = 2;
        d.idIndicatorTop = d.idIndicatorP2;
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}_C${d.idIndicatorP2}`;
      } else if (d.idIndicatorP1 !== null) {
        d.topLevel = 1;
        d.idIndicatorTop = d.idIndicatorP1;
        d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}`;
      }
      return d;
    });

    f_benchmark_10.forEach((a: any, i: number) => {
      a.map((d: any) => {
        d.joinKey = `A${d.idIndicator}`;
        if (d.idIndicatorP2 !== null) {
          d.topLevel = 2;
          d.idIndicatorTop = d.idIndicatorP2;
          d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}_C${d.idIndicatorP2}`;
        } else if (d.idIndicatorP1 !== null) {
          d.topLevel = 1;
          d.idIndicatorTop = d.idIndicatorP1;
          d.joinKey = `A${d.idIndicator}_B${d.idIndicatorP1}`;
        }
        return d;
      });
    });

    const f_data_bench: any = [];
    f_benchmark.forEach((d: any, i: any) => {
      f_data_bench[i] = d.map((b: any) => {
        let a: any = {};
        a[selectedBenchmarks[i].label] = b.value;
        a.idIndicatorP2 = b.idIndicatorP2;
        a.idIndicatorP1 = b.idIndicatorP1;
        a.idIndicator = b.idIndicator;
        a.topLevel = 0;
        a.idIndicatorTop = b.idIndicator;
        a.joinKey = `A${b.idIndicator}`;
        if (b.idIndicatorP2 !== null) {
          a.topLevel = 2;
          a.idIndicatorTop = b.idIndicatorP2;
          a.joinKey = `A${b.idIndicator}_B${b.idIndicatorP1}_C${b.idIndicatorP2}`;
        } else if (b.idIndicatorP1 !== null) {
          a.topLevel = 1;
          a.idIndicatorTop = b.idIndicatorP1;
          a.joinKey = `A${b.idIndicator}_B${b.idIndicatorP1}`;
        }

        const jaar10 =
          f_benchmark_10[i] !== undefined
            ? f_benchmark_10[i].filter(
                (item: any) => a.joinKey === item.joinKey,
              )
            : [];

        a[selectedBenchmarks[i].label + '_10'] = jaar10;
        return a;
      });
    });

    const map = new Map();
    f_data_bench[0].forEach((item: any) => map.set(item.joinKey, item));
    f_data_bench.forEach((d: any) => {
      d.forEach((item: any) =>
        map.set(item.joinKey, { ...map.get(item.joinKey), ...item }),
      );
    });
    const f_bench = Array.from(map.values());

    ////////////
    // const arr1 = [
    //   { id: 'abdc4051', date: '2017-01-24' },
    //   { id: 'abdc4052', date: '2017-01-22' },
    //   { id: 'abdc4053', date: '2017-01-22' },
    // ];
    // const arr2 = [
    //   { nameId: 'abdc4051', name: 'ab' },
    //   { nameId: 'abdc4052', name: 'abc' },
    // ];

    // const map = new Map();
    // arr1.forEach((item) => map.set(item.id, item));
    // arr2.forEach((item) =>
    //   map.set(item.nameId, { ...map.get(item.nameId), ...item }),
    // );
    // const mergedArr = Array.from(map.values());

    // 4(JSON.stringify(mergedArr));
    ////////////

    // TODO: Add benchmark values to factData

    const allIndicators = [
      ...new Set(f_indicator_thema.map((d: any) => d.idIndicator)),
    ];

    // Create a dataset with unique indicators on highest level, to render the table rows.
    const unique = [...new Set(f_gemeente.map((d: any) => d.idIndicatorTop))];

    // Add top level data
    let uniqueObjects: any = [];
    unique.forEach((d: any, i: number) => {
      const indicator = (d_indicator as any[]).find(
        (item) => parseInt(d) === parseInt(item.id),
      );

      if (indicator.indicatorType === 'Register') return;

      const dataLowestLevelTMP = (f_gemeente as any[]).filter(
        (item) => parseInt(d) === parseInt(item.idIndicatorTop),
      );

      const indicatorDetail = (d_indicator_detail as any[]).find(
        (item) =>
          parseInt(dataLowestLevelTMP[0]?.idIndicatorDetail) ===
          parseInt(item.id),
      );

      const d3format = indicatorDetail
        ? indicatorDetail.ratio === '%'
          ? `,.${parseInt(indicatorDetail.decimalen)}%`
          : `,.${parseInt(indicatorDetail.decimalen)}f`
        : ',.1f';

      // Lowest level data
      const dataLowestLevelTMP2 = dataLowestLevelTMP.map(
        (b: any, i: number) => {
          const indicator = (d_indicator as any[]).find(
            (item) => parseInt(b.idIndicator) === parseInt(item.id),
          );

          const samenvatting = (f_samenvatting_indicatoren as any[]).find(
            (item) => b.joinKey === item.joinKey,
          );

          const jaar10 = (f_gemeente_10 as any[]).filter(
            (item) => b.joinKey === item.joinKey,
          );

          const out: any = {};
          out.indicatorLabel = indicator?.indicator;

          out[selectedGemeente.label] = b.value;
          out.idIndicatorP1 = b.idIndicatorP1;
          out.idIndicatorP2 = b.idIndicatorP2;
          out.idIndicator = b.idIndicator;
          out.topLevel = b.topLevel;
          out.joinKey = b.joinKey;
          out.jaar = b.jaar;

          out.valueMin = samenvatting !== undefined ? samenvatting.valueMin : 0;
          out.valueMax = samenvatting !== undefined ? samenvatting.valueMax : 0;
          out.valueVlaamsGewest =
            samenvatting !== undefined ? samenvatting.valueVlaamsGewest : 0;

          out.d3format = d3format;
          out[selectedGemeente.label + '_10'] = jaar10;
          out.showInTable = indicator?.showInTable;
          out.sortering = indicator?.sortering;

          selectedBenchmarks.forEach((d: any, i: number) => {
            out[selectedBenchmarks[i].label] = null;
            out[selectedBenchmarks[i].label + '_10'] = [];
          });

          return out;
        },
      );

      dataLowestLevelTMP2.sort((a: any, b: any) => {
        return a.sortering - b.sortering;
      });

      const listOfKeys = [
        ...new Set(dataLowestLevelTMP2.map((d: any) => d.joinKey)),
      ];
      const f_bench_filtered = f_bench.filter((d: any) =>
        listOfKeys.includes(d.joinKey),
      );

      const map = new Map();
      dataLowestLevelTMP2.forEach((item: any) => map.set(item.joinKey, item));
      f_bench_filtered.forEach((item: any) =>
        map.set(item.joinKey, { ...map.get(item.joinKey), ...item }),
      );

      const dataLowestLevel = Array.from(map.values());

      // Add parent 1 data if needed (only in case of 2 levels)
      let parent1: any = dataLowestLevel;
      if (dataLowestLevel[0]?.topLevel === 2) {
        parent1 = [];
        const unique = [
          ...new Set(dataLowestLevel.map((d: any) => d.idIndicatorP1)),
        ];
        unique.forEach((a: any, i: number) => {
          const indicator = (d_indicator as any[]).find(
            (item) => parseInt(a) === parseInt(item.id),
          );

          const dataParent1 = (dataLowestLevel as any[]).filter(
            (item) => parseInt(a) === parseInt(item.idIndicatorP1),
          );
          const tmpOut = {
            id: a,
            idIndicatorP1: a,
            indicatorLabel: indicator?.indicator,
            detail: indicatorDetail,
            data: dataParent1,
            sortering: indicator?.sortering,
          };
          parent1.push(tmpOut);
        });
      }

      if (indicatorDetail?.visualisatieType === 'V_Top') {
        parent1.sort((a: any, b: any) => {
          return b[selectedGemeente.ruimte] - a[selectedGemeente.ruimte];
        });
      } else {
        parent1.sort((a: any, b: any) => {
          return a.sortering - b.sortering;
        });
      }

      const tmpOut = {
        id: d,
        idIndicatorTop: d,
        idThema: indicator?.idThema,
        indicatorLabel: indicator?.indicator,
        topLevel: dataLowestLevel[0]?.topLevel,
        data: parent1,
        detail: indicatorDetail,
        maxJaar: indicator?.maxJaar,
        bron: indicator?.bron,
      };

      if (tmpOut?.detail?.survey === '1') {
        uniqueObjects.push(tmpOut);
      }
    });

    uniqueObjects.map((a: any) => {
      if (
        a?.detail?.visualisatieType === 'V_Aandeel_meerdere' &&
        a?.topLevel === 2
      ) {
        let indicatorRows = a.data.map((d: any, i: number) => {
          const rowToKeep = d.data.find((d: any, i: number) => {
            return d.showInTable === 1;
          });
          let out = rowToKeep;
          out.indicatorLabel = d.indicatorLabel;
          return out;
        });
        a.data = indicatorRows;
        a.topLevel = 1;
      }

      return a;
    });

    let outData = uniqueObjects;

    if (selectedIndicators.length > 0) {
      outData = uniqueObjects.filter((d: any) => {
        return selectedIndicators.includes(d.id);
      });
    }

    outData.sort((a: any, b: any) => {
      if (!(a && a.indicatorLabel && b && b.indicatorLabel)) return;

      const stringA = a.indicatorLabel.toUpperCase(); // ignore upper and lowercase
      const stringB = b.indicatorLabel.toUpperCase(); // ignore upper and lowercase
      if (stringA > stringB) return 1;
      if (stringA < stringB) return -1;
      return 0;
    });
    console.log('outData', outData);

    // outData.sort((a: any, b: any) => {
    //   return a.topLevel - b.topLevel;
    // });

    const tmpIndData = outData.find(
      (d: any) => parseInt(d.id) === parseInt(selectedIndicator),
    );

    if (
      tmpIndData?.detail?.visualisatieType === 'V_Aandeel_meerdere' &&
      tmpIndData.topLevel === 2
    ) {
      let indicatorRows = tmpIndData.data.map((d: any, i: number) => {
        const rowToKeep = d.data.find((d: any, i: number) => {
          return d.showInTable === 1;
        });
        let out = rowToKeep;
        out.indicatorLabel = d.indicatorLabel;
        return out;
      });
      tmpIndData.data = indicatorRows;
      tmpIndData.topLevel = 1;
    }

    setSelectedIndicatorData(tmpIndData);
    setDataGemeente(outData);
  };

  const prepCols = () => {
    const scatterShartOneDimensionalProps = [
      {
        id: 0,
        fieldName: selectedGemeente.label,
        type: 'main',
        size: 1000,
      },
    ];

    const evoChartProps = [
      {
        id: 0,
        fieldName: selectedGemeente.label,
        type: 'main',
      },
    ];
    const stringOperators = getGridStringOperators().filter((op) =>
      ['contains', 'equals', 'startsWith', 'endsWith'].includes(op.value),
    );

    const tmpCols: any = [
      // {
      //   field: 'idIndicatorTop',
      //   cellClassName: 'vl-typography',
      //   headerName: 'ID',
      //   width: 50,
      //   hideable: false,
      // },

      {
        field: 'indicatorLabel',
        cellClassName: 'color--cell vl-typography',
        filterOperators: stringOperators,
        headerName: <p style={{ paddingLeft: '8px' }}>Indicator</p>,
        width: 300,
        hideable: false,
        renderCell: (row: any) => {
          let pad = 40;

          const type = row?.row?.detail?.survey === '1' ? 'survey' : 'register';

          const out = row?.row?.detail
            ? row?.row?.detail?.ratio === '%'
              ? '(procent - ' + type + ')'
              : '(' +
                row?.row?.detail?.eenheid +
                ' ' +
                row?.row?.detail?.ratio +
                ' - ' +
                type +
                ')'
            : '(-)';

          if (
            row?.row?.topLevel === 0 ||
            row?.row?.detail?.visualisatieType === 'V_Aandeel' ||
            row?.row?.detail?.visualisatieType === 'V_Cat'
          ) {
            return (
              <Grid
                container
                width="100%"
                height="100%"
                //paddingTop={`${pad}px`}
                paddingBottom={`${pad}px`}
              >
                <div style={{ height: '64px' }}>
                  <p
                    style={{ marginBottom: '2px', paddingLeft: '8px' }}
                    title={row.row.indicatorLabel}
                  >
                    {row.row.indicatorLabel}{' '}
                  </p>
                  <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
                </div>
              </Grid>
            );
          } else if (row?.row?.topLevel === 1) {
            let factor = 0;

            row?.row?.data.forEach((b: any) => {
              if (b.showInTable === 1) factor += 1;
            });

            if (row?.row?.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  //paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  <div style={{ height: '64px' }}>
                    <p
                      style={{ marginBottom: '2px', paddingLeft: '8px' }}
                      title={row.row.indicatorLabel}
                    >
                      {row.row.indicatorLabel}{' '}
                    </p>
                    <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      top: '-25px',
                    }}
                  >
                    {row.row.data.map((d: any, i: number) => {
                      if (d.showInTable === 1) {
                        return (
                          <Grid
                            container
                            width="100%"
                            sx={{
                              height: `calc((100% - 38px) / ${factor})`,
                              position: 'relative',
                            }}
                          >
                            <Grid item xs={12} sx={{ height: '100%' }}>
                              <svg width="100%" height="100%">
                                <rect
                                  x="0"
                                  y="0"
                                  width="100%"
                                  height="100%"
                                  stroke="red"
                                  strokeWidth="0"
                                  fill="transparent"
                                />
                                <text
                                  x="95%"
                                  y="50%"
                                  dominantBaseline="middle"
                                  textAnchor="end"
                                >
                                  {d.indicatorLabel}
                                </text>
                              </svg>
                            </Grid>
                          </Grid>
                        );
                      }
                    })}
                  </div>
                </Grid>
              );
            }
          } else if (
            row?.row?.detail?.visualisatieType === 'V_Aandeel_meerdere'
          ) {
            let indicatorRows = row.row.data.map((d: any, i: number) => {
              const rowToKeep = d.data.find((d: any, i: number) => {
                return d.showInTable === 1;
              });
              let out = rowToKeep;
              out.indicatorLabel = d.indicatorLabel;
              return out;
            });
            row.row.data = indicatorRows;
            row.row.topLevel = 1;

            let factor = 0;

            row?.row?.data.forEach((b: any) => {
              if (b.showInTable === 1) factor += 1;
            });

            if (row?.row?.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  //paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  <div style={{ height: '64px' }}>
                    <p
                      style={{ marginBottom: '2px', paddingLeft: '8px' }}
                      title={row.row.indicatorLabel}
                    >
                      {row.row.indicatorLabel}{' '}
                    </p>
                    <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
                  </div>
                  <div
                    style={{
                      height: '100%',
                      width: '100%',
                      position: 'relative',
                      top: '-25px',
                    }}
                  >
                    {row.row.data.map((d: any, i: number) => {
                      if (d.showInTable === 1) {
                        return (
                          <Grid
                            container
                            width="100%"
                            sx={{
                              height: `calc((100% - 38px) / ${factor})`,
                              position: 'relative',
                            }}
                          >
                            <Grid item xs={12} sx={{ height: '100%' }}>
                              <svg width="100%" height="100%">
                                <rect
                                  x="0"
                                  y="0"
                                  width="100%"
                                  height="100%"
                                  stroke="red"
                                  strokeWidth="0"
                                  fill="transparent"
                                />
                                <text
                                  x="95%"
                                  y="50%"
                                  dominantBaseline="middle"
                                  textAnchor="end"
                                >
                                  {d.indicatorLabel}
                                </text>
                              </svg>
                            </Grid>
                          </Grid>
                        );
                      }
                    })}
                  </div>
                </Grid>
              );
            }
          } else if (row?.row?.topLevel === 2) {
            let factor = 0;

            row?.row?.data.forEach((b: any) => {
              b.data.forEach((c: any) => {
                if (c.showInTable === 1) factor += 1;
              });
            });

            return (
              <Grid
                container
                width="100%"
                height="100%"
                //paddingTop={`${pad}px`}
                paddingBottom={`${pad}px`}
              >
                <div style={{ height: '64px' }}>
                  <p
                    style={{ marginBottom: '2px', paddingLeft: '8px' }}
                    title={row.row.indicatorLabel}
                  >
                    {row.row.indicatorLabel}{' '}
                  </p>
                  <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
                </div>
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                    top: '-25px',
                  }}
                >
                  {row.row.data.map((a: any, i: number) => {
                    return a.data.map((d: any, i: number) => {
                      if (d.showInTable === 1) {
                        return (
                          <Grid
                            container
                            sx={{
                              width: '100%',
                              height: `calc((100% - 38px) / ${factor})`,
                              position: 'relative',
                            }}
                          >
                            <Grid item xs={12} sx={{ height: '100%' }}>
                              <svg width="100%" height="100%">
                                <rect
                                  x="0"
                                  y="0"
                                  width="100%"
                                  height="100%"
                                  stroke="red"
                                  strokeWidth="0"
                                  fill="transparent"
                                />
                                <text
                                  x="95%"
                                  y="50%"
                                  dominantBaseline="middle"
                                  textAnchor="end"
                                >
                                  {a.indicatorLabel + ' - ' + d.indicatorLabel}
                                </text>
                              </svg>
                            </Grid>
                          </Grid>
                        );
                      }
                    });
                  })}
                </div>
              </Grid>
            );
          } else {
            return (
              <Grid
                container
                width="100%"
                height="100%"
                //paddingTop={`${pad}px`}
                paddingBottom={`${pad}px`}
              >
                <div style={{ height: '64px' }}>
                  <p
                    style={{ marginBottom: '2px', paddingLeft: '8px' }}
                    title={row.row.indicatorLabel}
                  >
                    {row.row.indicatorLabel}{' '}
                  </p>
                  <p style={{ paddingLeft: '8px', opacity: 0.8 }}>{out}</p>
                </div>
              </Grid>
            );
          }
        },
      },

      {
        field: 'visual',
        cellClassName: 'vl-typography',
        headerName: (
          <div style={{ width: '100%' }}>
            <div style={{ display: 'inline-block' }}>
              <span
                style={{
                  height: '12px',
                  width: '12px',
                  backgroundColor: gemeenteColor,
                  borderRadius: '50%',
                  display: 'inline-block',
                  marginLeft: '24px',
                  marginRight: '4px',
                }}
              ></span>
              {selectedGemeente.ruimte}
            </div>
            {selectedBenchmarks.map((d: any, i: number) => {
              return (
                <div style={{ display: 'inline-block' }}>
                  <span
                    style={{
                      height: '12px',
                      width: '12px',
                      backgroundColor: 'transparent',
                      border: `2px solid ${benchColors[i]}`,
                      borderRadius: '50%',
                      display: 'inline-block',
                      marginLeft: '24px',
                      marginRight: '4px',
                    }}
                  ></span>
                  {d.ruimte}
                </div>
              );
            })}
            <div style={{ display: 'inline-block' }}>
              <span
                style={{
                  height: '12px',
                  width: '2px',
                  backgroundColor: vgColor,

                  display: 'inline-block',
                  marginLeft: '24px',
                  marginRight: '4px',
                }}
              ></span>
              Vlaams Gewest
            </div>
          </div>
        ),
        description: (
          <>
            <div style={{ display: 'inline-block' }}>
              <span
                style={{
                  height: '12px',
                  width: '12px',
                  backgroundColor: gemeenteColor,
                  borderRadius: '50%',
                  display: 'inline-block',
                  marginLeft: '24px',
                  marginRight: '4px',
                }}
              ></span>
              {selectedGemeente.ruimte}
            </div>
            {selectedBenchmarks.map((d: any, i: number) => {
              return (
                <div style={{ display: 'inline-block' }}>
                  <span
                    style={{
                      height: '12px',
                      width: '12px',
                      backgroundColor: 'transparent',
                      border: `2px solid ${benchColors[i]}`,
                      borderRadius: '50%',
                      display: 'inline-block',
                      marginLeft: '24px',
                      marginRight: '4px',
                    }}
                  ></span>
                  {d.ruimte}
                </div>
              );
            })}
            <div style={{ display: 'inline-block' }}>
              <span
                style={{
                  height: '12px',
                  width: '2px',
                  backgroundColor: vgColor,

                  display: 'inline-block',
                  marginLeft: '24px',
                  marginRight: '4px',
                }}
              ></span>
              Vlaams Gewest
            </div>
          </>
        ),
        // width: 820,
        flex: 1,
        sortable: false,
        filterable: false,
        renderCell: (row: any) => {
          let pad = 40;
          let mainOnly = false;
          if (row?.row?.detail?.visualisatieType === 'V_Top') {
            mainOnly = true;
          }

          if (row.row.topLevel === 0) {
            // pad = 0;

            if (row.row.data[0] !== undefined) {
              let outData = row.row.data[0];
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  <Grid item xs={12} sx={{ height: '100%' }}>
                    {renderDotChart(
                      outData,
                      'joinKey',
                      scatterShartOneDimensionalProps,
                      mainOnly,
                    )}
                  </Grid>
                </Grid>
              );
            } else {
              return '';
            }
          } else if (row.row.topLevel === 1) {
            let factor = 0;
            row.row.data.forEach((b: any) => {
              if (b.showInTable === 1) factor += 1;
            });
            if (row.row.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  {row.row.data.map((d: any, i: number) => {
                    if (d.showInTable === 1) {
                      return (
                        <Grid
                          container
                          width="100%"
                          sx={{ height: `calc(100% / ${factor})` }}
                        >
                          <Grid item xs={12} sx={{ height: '100%' }}>
                            {renderDotChart(
                              d,
                              'joinKey',
                              scatterShartOneDimensionalProps,
                              mainOnly,
                            )}
                          </Grid>
                        </Grid>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Grid>
              );
            } else {
              return '';
            }
          } else if (row?.row?.topLevel === 2) {
            let factor = 0;

            row?.row?.data.forEach((b: any) => {
              b.data.forEach((c: any) => {
                if (c.showInTable === 1) factor += 1;
              });
            });
            if (row.row.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  {row.row.data.map((e: any, i: number) => {
                    return e.data.map((d: any, i: number) => {
                      if (d.showInTable === 1) {
                        return (
                          <Grid
                            container
                            width="100%"
                            sx={{ height: `calc(100% / ${factor})` }}
                          >
                            <Grid item xs={12} sx={{ height: '100%' }}>
                              {renderDotChart(
                                d,
                                'joinKey',
                                scatterShartOneDimensionalProps,
                                mainOnly,
                              )}
                            </Grid>
                          </Grid>
                        );
                      } else {
                        return null;
                      }
                    });
                  })}
                </Grid>
              );
            } else {
              return '';
            }
          } else {
            return <div>Probleempje met de data</div>;
          }
        },
      },

      {
        field: 'visual_evo',
        cellClassName: 'vl-typography',
        headerName: <div>Evolutie</div>,
        width: 350,
        sortable: false,
        filterable: false,
        renderCell: (row: any) => {
          let pad = 40;
          if (row?.row?.detail?.visualisatieType === 'V_Top') return null;
          if (row.row.topLevel === 0) {
            // pad = 0;
            if (row.row.data[0] !== undefined) {
              let outData = row.row.data[0];
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  <Grid item xs={12} sx={{ height: '100%' }}>
                    {renderEvoChart(outData, 'joinKey', evoChartProps)}
                  </Grid>
                </Grid>
              );
            } else {
              return '';
            }
          } else if (row.row.topLevel === 1) {
            let factor = 0;
            row.row.data.forEach((b: any) => {
              if (b.showInTable === 1) factor += 1;
            });
            if (row.row.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  {row.row.data.map((d: any, i: number) => {
                    if (d.showInTable === 1) {
                      return (
                        <Grid
                          container
                          width="100%"
                          sx={{ height: `calc(100% / ${factor})` }}
                        >
                          <Grid item xs={12} sx={{ height: '100%' }}>
                            {renderEvoChart(d, 'joinKey', evoChartProps)}
                          </Grid>
                        </Grid>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Grid>
              );
            }
          } else if (row?.row?.topLevel === 2) {
            let factor = 0;

            row?.row?.data.forEach((b: any) => {
              b.data.forEach((c: any) => {
                if (c.showInTable === 1) factor += 1;
              });
            });

            if (row.row.data[0] !== undefined) {
              return (
                <Grid
                  container
                  width="100%"
                  height="100%"
                  paddingTop={`${pad}px`}
                  paddingBottom={`${pad}px`}
                >
                  {row.row.data.map((e: any, i: number) => {
                    return e.data.map((d: any, i: number) => {
                      if (d.showInTable === 1) {
                        return (
                          <Grid
                            container
                            width="100%"
                            sx={{ height: `calc(100% / ${factor})` }}
                          >
                            <Grid item xs={12} sx={{ height: '100%' }}>
                              {renderEvoChart(d, 'joinKey', evoChartProps)}
                            </Grid>
                          </Grid>
                        );
                      } else {
                        return null;
                      }
                    });
                  })}
                </Grid>
              );
            } else {
              return '';
            }
          } else {
            return <div>Probleempje met de data</div>;
          }
        },
      },
      // {
      //   field: 'detail.survey',
      //   cellClassName: 'vl-typography',
      //   headerName: 'Type',
      //   filterable: false,
      //   sortable: false,
      //   width: 120,
      //   renderCell: (params: any) => {
      //     const out = params.row.detail ? (
      //       params.row.detail.survey === '1' ? (
      //         <p style={{ fontSize: 14, paddingLeft: 4 }} title="Survey">
      //           <FcSurvey />

      //           <span> Survey</span>
      //         </p>
      //       ) : (
      //         <p
      //           style={{ fontSize: 14, paddingLeft: 4 }}
      //           title="Register databank"
      //         >
      //           <FcAcceptDatabase /> <span> Register</span>
      //         </p>
      //       )
      //     ) : (
      //       <p style={{ fontSize: 30, paddingLeft: 4 }} title="Ontbrekend type">
      //         /
      //       </p>
      //     );
      //     return <div>{out}</div>;
      //   },
      // },
      {
        field: 'detail.ido',
        cellClassName: 'vl-typography',
        headerName: 'IDO',

        sortable: true,
        width: 80,
        renderCell: (params: any) => {
          const out = params.row.detail ? <p>{params.row.detail.ido}</p> : '';

          return <div>{out}</div>;
        },
      },
    ];

    selectedBenchmarks.forEach((d: any, i: any) => {
      scatterShartOneDimensionalProps.push({
        id: i + 1,
        fieldName: d.label,
        type: 'benchmark',
        size: 1000,
      });

      evoChartProps.push({
        id: i + 1,
        fieldName: d.label,
        type: 'benchmark',
      });
    });

    setCols(tmpCols);
  };

  const renderDotChart = (
    props: any,
    idField: any,
    scatterShartOneDimensionalProps: any[],
    mainOnly: boolean,
  ) => {
    const arr = [props];
    let theProps = scatterShartOneDimensionalProps;
    if (mainOnly) {
      theProps = scatterShartOneDimensionalProps.filter((d: any, i: number) => {
        return i === 0;
      });
    }

    return (
      <ScatterChartOneDimensionalInteractieveTool
        data={arr}
        idField={idField}
        visualProps={theProps}
        mainOnly={mainOnly}
      ></ScatterChartOneDimensionalInteractieveTool>
    );
  };

  const renderEvoChart = (props: any, idField: any, evoProps: any[]) => {
    const data = props;

    let allData: any = [];

    let colorsLine: any = [];

    evoProps.forEach((d, i) => {
      data[d.fieldName + '_10'] &&
        data[d.fieldName + '_10'].forEach((item: any) => allData.push(item));

      const color = d.type === 'main' ? gemeenteColor : benchColors[i - 1];
      colorsLine.push(color);
    });

    allData.sort((a: any, b: any) => a.jaar - b.jaar);

    const categories = [...new Set(allData.map((d: any) => d.jaar))];

    const out = categories.map((d) => {
      let a: any = {};
      a.jaar = d;
      a.d3format = data.d3format;
      a[selectedGemeente.ruimte] = allData.find(
        (all: any) =>
          parseInt(all.jaar) === parseInt(d) &&
          parseInt(all.idRuimte) === parseInt(selectedGemeente.idRuimte),
      )?.value;
      selectedBenchmarks.forEach((bench: any, i: number) => {
        a[bench.ruimte] = allData.find(
          (all: any) =>
            parseInt(all.jaar) === parseInt(d) &&
            parseInt(all.idRuimte) === parseInt(bench.idRuimte),
        )?.value;
      });
      return a;
    });

    return (
      <LineChartSimple
        data={out}
        idField={idField}
        visualProps={evoProps}
        colors={colorsLine}
      ></LineChartSimple>
    );
  };

  useEffect(() => {
    setIsLoading(true);
    let data =
      dataGemeente[0]?.topLevel === 2
        ? dataGemeente[0]?.data[0]?.data[0]
        : dataGemeente[0]?.data[0];

    if (!data) return;

    const gemRefreshed = Object.keys(data).includes(selectedGemeente.ruimte);

    let count = 0;
    selectedBenchmarks.forEach((d: any) => {
      if (Object.keys(data).includes(d.ruimte)) {
        count += 1;
      }
    });

    const benchRefreshed = count === selectedBenchmarks.length;

    if (gemRefreshed && benchRefreshed) {
      setIsLoading(false);
    }
  }, [selectedGemeente, selectedBenchmarks, selectedIndicators, dataGemeente]);

  useEffect(() => {
    if (
      hasRunOnce &&
      d_indicator &&
      d_thema &&
      f_gemeente &&
      f_gemeente_10 &&
      f_samenvatting_indicatoren &&
      d_indicator_detail &&
      (f_benchmark0 ||
        f_benchmark1 ||
        f_benchmark2 ||
        f_benchmark3 ||
        f_benchmark4 ||
        f_benchmark5) &&
      (f_benchmark0_10 ||
        f_benchmark1_10 ||
        f_benchmark2_10 ||
        f_benchmark3_10 ||
        f_benchmark4_10 ||
        f_benchmark5_10)
    ) {
      f_samenvatting_indicatoren.sort((a: any, b: any) => {
        return a.idIndicator - b.idIndicator;
      });

      f_benchmark = [];
      f_benchmark0 && f_benchmark.push(f_benchmark0);
      f_benchmark1 && f_benchmark.push(f_benchmark1);
      f_benchmark2 && f_benchmark.push(f_benchmark2);
      f_benchmark3 && f_benchmark.push(f_benchmark3);
      f_benchmark4 && f_benchmark.push(f_benchmark4);
      f_benchmark5 && f_benchmark.push(f_benchmark5);

      f_benchmark_10 = [];
      f_benchmark0_10 && f_benchmark_10.push(f_benchmark0_10);
      f_benchmark1_10 && f_benchmark_10.push(f_benchmark1_10);
      f_benchmark2_10 && f_benchmark_10.push(f_benchmark2_10);
      f_benchmark3_10 && f_benchmark_10.push(f_benchmark3_10);
      f_benchmark4_10 && f_benchmark_10.push(f_benchmark4_10);
      f_benchmark5_10 && f_benchmark_10.push(f_benchmark5_10);

      setThemas(
        d_thema.filter((d: any) => {
          return d.id !== 0;
        }),
      );
      setIndicators(d_indicator);
      prepData();
      prepCols();
    }
  }, [
    d_indicator,
    d_thema,
    f_gemeente,
    f_gemeente_10,
    f_benchmark0,
    f_benchmark1,
    f_benchmark2,
    f_benchmark3,
    f_benchmark4,
    f_benchmark5,
    f_benchmark0_10,
    f_benchmark1_10,
    f_benchmark2_10,
    f_benchmark3_10,
    f_benchmark4_10,
    f_benchmark5_10,
    f_samenvatting_indicatoren,
    d_indicator_detail,
    hasRunOnce,
    selectedIndicators,
  ]);

  const getAndSetRuimteByLabel = (label: any) => {
    if (label !== null) {
      let records = d_ruimte.filter((d: any) => {
        return (
          d.ruimte === decodeURI(label) &&
          d.typeRuimte === 'Gemeente' &&
          parseInt(d.isFusie) === 1
        );
      });

      if (records !== undefined && records.length > 0) {
      } else {
        records = d_ruimte.filter((d: any) => {
          return d.id === 8811002;
        });
      }

      let ruimte = structuredClone(records[0]);
      ruimte.id = parseInt(ruimte.id);
      ruimte.label = ruimte.ruimte;

      setSelectedGemeente(ruimte);

      const trimmedUrl = window.location.href.split('/').shift();
      const path =
        additionalData?.pageSettings?.relationships?.field_fusion_data?.path
          ?.alias;

      const url = `${trimmedUrl}${path}?gemeente=${ruimte.ruimte}`;
      const param = searchParams.get('indicator');
      if (param) {
        searchParams.delete('indicator');

        setSearchParams((params) => {
          params.set('gemeente', ruimte.ruimte);
          return params;
        });
        useUrlUpdate(url);
      }

      if (selectedBenchmarks.id === 2000) {
        let defaultBench = d_ruimte.find(
          (d: any) => parseInt(d.isVlaamsGewest) === 1,
        );

        defaultBench.label = defaultBench.ruimte;
        setSelectedBenchmarks([defaultBench]);
      }
    }
  };

  function useUrlUpdate(url: string) {
    if (typeof window !== `undefined` && typeof url !== `undefined`) {
      window.history.pushState({}, '', url);
    }
    return;
  }

  useEffect(() => {
    if (selectedIndicator === undefined && dataGemeente?.length > 0) {
      setSelectedIndicator(dataGemeente[0].id);
      setSelectedIndicatorData(dataGemeente[0]);
    }
  }, [dataGemeente, selectedIndicator]);

  useEffect(() => {
    if (d_ruimte && d_indicator && !hasRunOnce) {
      const filteredIds = d_indicator.map((item: any) => item.id);
      setSelectedIndicators(filteredIds);

      if (selectedBenchmarks.length > 0) {
        setSelectedBenchmarks((prev) => {
          return prev.filter((d: any) => {
            return d.isFusie === 0;
          });
        });
      }

      const searchKeywordCity = searchParams.get('gemeente');
      const searchKeywordIndicator = searchParams.get('indicator');

      if (searchKeywordCity === null && selectedGemeente.id === -1) {
        const defaultGemeente = d_ruimte.find((d: any) => d.id === 8811002);
        defaultGemeente.label = defaultGemeente.ruimte;

        if (selectedBenchmarks.id === 2000) {
          let defaultBench = d_ruimte.find(
            (d: any) => parseInt(d.isVlaamsGewest) === 1,
          );
          defaultBench.label = defaultBench.ruimte;
          setSelectedBenchmarks([defaultBench]);
        }

        setSelectedGemeente(defaultGemeente);
        setToggled(true);

        const param = searchParams.get('indicator');
        if (param) {
          searchParams.delete('indicator');
        }

        setSearchParams((params) => {
          params.set('gemeente', defaultGemeente.ruimte);
          return params;
        });

        const trimmedUrl = window.location.href.split('/').shift();
        const path =
          additionalData?.pageSettings?.relationships?.field_fusion_data?.path
            ?.alias;

        const url = `${trimmedUrl}${path}?gemeente=${defaultGemeente.ruimte}`;
        useUrlUpdate(url);
      } else {
        getAndSetRuimteByLabel(searchKeywordCity);
      }

      if (searchKeywordIndicator !== null) {
        let ind = d_indicator.filter(
          (d: any) =>
            d.code === searchKeywordIndicator &&
            parseInt(d.isHoofdIndicator) === 1,
        );

        if (ind?.length === 1) {
          ind = ind[0];
        } else if (ind?.length > 1) {
          ind = ind[ind.length - 1];
        } else {
          ind = undefined;
        }

        setSelectedIndicator(ind?.id);
        setSelectedIndicators([ind?.id]);
        // scrollToRef(detailSection);
        setSearchParams((params) => {
          params.set('indicator', ind?.code);
        });
      }

      setHasRunOnce(true);
    }
  }, [hasRunOnce, d_ruimte, d_indicator, selectedGemeente]);

  useEffect(() => {
    if (d_ruimte && d_benchmark && hasRunOnce) {
      const vlgewest = d_ruimte.filter((d: any) => {
        return parseInt(d?.isVlaamsGewest) === 1;
      });

      const centrumSteden = d_ruimte.filter((d: any) => {
        return parseInt(d?.is13CentrumSteden) === 1;
      });

      const facil = d_ruimte.filter((d: any) => {
        return parseInt(d?.isFaciliteitenGemeente) === 1;
      });

      const nietFacil = d_ruimte.filter((d: any) => {
        return parseInt(d?.isNietFaciliteitenGemeente) === 1;
      });

      const vlRand = d_ruimte.filter((d: any) => {
        return parseInt(d?.isVlaamseRand) === 1;
      });

      const belfius = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteBelfiusCluster)
        );
      });

      const buurGem = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteBuurgemeenten)
        );
      });

      const gemGrootte = d_ruimte.filter((d: any) => {
        return (
          parseInt(d.id) === parseInt(selectedGemeente?.idRuimteGemeenteGrootte)
        );
      });

      const prov = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteProvincie);
      });

      const regio = d_ruimte.filter((d: any) => {
        return parseInt(d.id) === parseInt(selectedGemeente?.idRuimteRegio);
      });

      const allBench = vlgewest
        .concat(
          prov,
          regio,
          belfius,
          gemGrootte,
          buurGem,
          centrumSteden,
          vlRand,
          facil,
          nietFacil,
        )
        .map((d: any) => {
          d.bench = 1;
          return d;
        });

      const allCities = d_ruimte
        .filter((d: any) => {
          return parseInt(d.isVlaamseGemeente) === 1;
        })

        .sort((a: any, b: any) => {
          let fa = a.ruimte.toLowerCase(),
            fb = b.ruimte.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        })
        .map((d: any) => {
          d.bench = 0;
          return d;
        });

      // const citiesBench = vlgewest.concat(sortedCities);
      const citiesBench = allBench.concat(allCities).filter((d: any) => {
        return parseInt(d.id) !== parseInt(selectedGemeente?.id);
      });

      const sortedCities = d_ruimte
        .filter((d: any) => {
          return (
            parseInt(d.isVlaamseGemeente) === 1 && parseInt(d.isFusie) === 1
          );
        })

        .sort((a: any, b: any) => {
          let fa = a.ruimte.toLowerCase(),
            fb = b.ruimte.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        })
        .map((d: any) => {
          d.bench = 0;
          return d;
        });

      // compare currently selected benchmarks with benchmarks in list to see if there are no illegal selections
      const uniqueBenchIDs = [...new Set(allBench.map((d: any) => d.id))];

      let selBench = selectedBenchmarks.filter((d: any) => {
        return parseInt(d.isGemeente) || uniqueBenchIDs.includes(d.id);
      });

      if (selBench.length === 0) {
        selBench = d_ruimte.find((d: any) => parseInt(d.isVlaamsGewest) === 1);
        selBench.label = selBench.ruimte;
        selBench = [selBench];
      }

      setGemeenteLijst(sortedCities);
      setBenchmarkLijst(citiesBench);
      setSelectedBenchmarks(selBench);

      const trimmedUrl = window.location.href.split('/').shift();
      const path =
        additionalData?.pageSettings?.relationships?.field_fusion_data?.path
          ?.alias;

      const url = `${trimmedUrl}${path}?gemeente=${selectedGemeente.ruimte}`;
      const param = searchParams.get('indicator');
      if (param) {
        searchParams.delete('indicator');
      }

      setSearchParams((params) => {
        params.set('gemeente', selectedGemeente.ruimte);
        return params;
      });
      useUrlUpdate(url);
    }
  }, [d_ruimte, d_benchmark, hasRunOnce, selectedGemeente]);

  useEffect(() => {
    let indThema: any = f_indicator_thema?.map((d: any) => {
      const indicator = d_indicator?.find((a: any) => {
        return a.id === d.idIndicator;
      });
      d.indicator = indicator?.indicator;
      return d;
    });

    indThema?.sort((a: any, b: any) => {
      if (!(a && a.indicator && b && b.indicator)) return;

      const stringA = a.indicator.toUpperCase(); // ignore upper and lowercase
      const stringB = b.indicator.toUpperCase(); // ignore upper and lowercase
      if (stringA > stringB) return 1;
      if (stringA < stringB) return -1;
      return 0;
    });

    indThema = indThema?.filter((d: any) => {
      return d.isSurvey === 1;
    });

    setIndicatorThema(indThema);
  }, [d_indicator, f_indicator_thema]);

  const onChangeIndicatorHandler = (event: any) => {
    event.preventDefault();

    let newObj = dataGemeente.find(
      (d: any) => parseInt(d.id) === parseInt(event.target.value),
    );

    newObj !== undefined && setSelectedIndicator(newObj?.id);
    newObj !== undefined && setSelectedIndicatorData(newObj);
  };

  return (
    <Grid container>
      <Grid item xs={12} ref={titleSection}>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            paddingTop: '24px',
            maxWidth: '95%',
          }}
        >
          <h5 className="page-title-mobile" style={{ marginBottom: '2px' }}>
            Surveyresultaten gefuseerde gemeenten
          </h5>
          <p className="page-subtitle-mobile" style={{ color: 'black' }}>
            Op deze pagina kan je de resultaten van de burgerbevraging
            Gemeente-Stadsmonitor raadplegen voor{' '}
            <a
              href="https://www.vlaanderen.be/lokaal-bestuur/samenwerking-fusies-regiovorming-en-verzelfstandiging/overzicht-fusies"
              target="_blank"
            >
              de 28 gemeenten die in 2025 gefuseerd zijn
            </a>{' '}
            tot 13 nieuwe fusiegemeenten. Je kan vrij benchmarken met andere
            gemeenten of ruimere gebiedsomschrijvingen. Surveyresultaten voor de
            nieuwe fusiegemeenten komen eraan bij de nieuwe burgerbevraging in
            2026.
          </p>
          <br />
          <p className="page-subtitle-mobile">
            Kies je benchmarks, selecteer indicatoren en duik dieper in de
            cijfers voor {selectedGemeente.ruimte}
          </p>
        </div>
      </Grid>

      <Grid xs={12}>
        <div
          className={'vl-typography'}
          style={{
            color: interfaceColor,
            paddingTop: '20px',
            paddingBottom: '16px',
            paddingLeft: '24px',
          }}
        >
          <p
            onClick={handleOpen}
            style={{
              width: '120px',
              marginBottom: '0px',
              textDecoration: 'underline',
              fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            Pas je selecties aan
          </p>

          <SelectionPanel
            open={open}
            setOpen={setOpen}
            themas={themas}
            indicatorThema={indicatorThema}
            gemeenteLijst={gemeenteLijst}
            selectedGemeente={selectedGemeente}
            selectedBenchmarks={selectedBenchmarks}
            benchmarkLijst={benchmarkLijst}
            setBenchmarkLijst={setBenchmarkLijst}
            d_ruimte={d_ruimte}
          />
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        pl={0}
        pr={0}
        height={'52px'}
        minHeight={'52px'}
        sx={{ position: 'relative' }}
        ref={tableSection}
      >
        <div
          style={{
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '8px',
            paddingBottom: '8px',
          }}
        >
          <select
            name="gemeente"
            className="vl-select vl-select--block"
            tabIndex={0}
            data-vl-select=""
            data-vl-select-search-empty-text="Geen resultaten gevonden"
            onChange={onChangeIndicatorHandler}
            style={{ fontSize: '11px', lineHeight: '13px' }}
          >
            {dataGemeente.map((d: any, i: number) => {
              return (
                <option
                  key={d.id}
                  value={d.id}
                  selected={
                    selectedIndicator !== undefined
                      ? d.id === selectedIndicator
                      : false
                  }
                >
                  <p>{d.indicatorLabel}</p>
                </option>
              );
            })}
          </select>
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        pl={'12px'}
        pr={'12px'}
        height={'auto'}
        sx={{ position: 'relative' }}
        ref={detailSection}
      >
        <div style={{ height: '100%' }}>
          <InteractieveToolMobileDetail
            detailData={selectedIndicatorData}
            additionalData={additionalData}
            refUp={tableSection}
            refCurrent={detailSection}
            refDown={null}
          />
        </div>
      </Grid>
    </Grid>
  );
};
